export default __webpack_public_path__ + "static/media/app1.894041b9.png";